const baseUrl = process.env.NEXT_PUBLIC_API_URL;

const tryParseResponse = (response) => response.json().catch(() => null);

const handleBadRequestError = (error, defaultError) => {
  if (!error) {
    throw Error(defaultError);
  }
  const message = error.message;
  if (!message) {
    throw Error(defaultError);
  }
  const [_, errorMessage = defaultError] = message.split(':');
  throw Error(errorMessage);
};

export async function signUp(body) {
  const response = await fetch(`${baseUrl}/sign-up`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (response.status === 409) {
    throw Error('The user already exists.');
  }

  const defaultError = 'There was an error signing up';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await tryParseResponse(response);

  return result;
}

export async function verifyIfUserExists(body) {
  const response = await fetch(`${baseUrl}/user-exists`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const result = await tryParseResponse(response);

  return result;
}

export async function createUserOrganizationRelation(body) {
  try {
    const response = await fetch(`${baseUrl}/user-organization-relation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const result = await tryParseResponse(response);

    return result;
  } catch (error) {
    console.error("error en api", error)
  }

}

export async function getDefaultConfig(token, userId, orgId) {
  try {
    const response = await fetch(`${baseUrl}/get-default-config/${orgId}/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    });

    const result = await tryParseResponse(response);

    return result;
  } catch (error) {
    console.error("error al obtener configuracion default", error)
  }

}


export async function updateDefaultConfig(token, userId, orgId, body) {
  try {
    const response = await fetch(`${baseUrl}/update-default-config/${orgId}/${userId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const result = await tryParseResponse(response);

    return result;
  } catch (error) {
    console.error("error al actualizar configuracion default", error)
  }

}


export async function createTenant(body) {
  try {
    const response = await fetch(`${baseUrl}/create-tenant`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const result = await tryParseResponse(response);

    return result;
  } catch (error) {
    console.error("error en api", error)
  }

}

export async function createOrganization(userId, body, organizationId) {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (organizationId) {
      headers['flex-organization'] = organizationId;
    }

    if (userId) {
      headers['flex-user'] = userId;
    }

    const response = await fetch(`${baseUrl}/create-organization`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });

    const result = await tryParseResponse(response);
    return result;
  } catch (error) {
    console.error("error en api", error);
  }
}


export async function signUpWithOrganization(data) {
  const { organizationId, ...body } = data;
  const response = await fetch(`${baseUrl}/sign-up/${organizationId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (response.status === 409) {
    throw Error('The user already exists.');
  }

  const defaultError = 'There was an error signing up';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await tryParseResponse(response);

  return result;
}

export async function findInvite(inviteId) {
  const response = await fetch(`${baseUrl}/find-invite/${inviteId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error finding your invite');
  }

  const result = await response.json();

  return result;
}
export async function forgotPassword(email) {
  if (!email) {
    throw new Error('Email is required');
  }
  const response = await fetch(`${baseUrl}/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  if (response.status === 400) {
    throw Error('Invalid email');
  }

  if (response.status !== 200) {
    throw Error('There was an error resetting your password');
  }

  const result = await response.json();

  return result;
}

export async function verifyEmail(verificationId, authCode) {
  const response = await fetch(`${baseUrl}/verify-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ verificationId, authCode }),
  });

  const defaultError = 'There was an error verifying your email';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    handleBadRequestError(error, defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await tryParseResponse(response);

  return result;
}

export async function sendInvites(organizationId, invites, token) {
  const response = await fetch(`${baseUrl}/send-invites`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ organizationId, invites }),
  });

  if (response.status !== 200) {
    throw Error('There was an error sending invites');
  }

  const result = await response.json();

  return result;
}

export async function changePassword(token) {
  const response = await fetch(`${baseUrl}/change-password`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error changing your password');
  }

  const result = await response.json();

  return result;
}

export async function resendAuthCode(verificationId) {
  const response = await fetch(`${baseUrl}/resend-authcode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ verificationId }),
  });

  if (response.status !== 200) {
    throw Error('There was an error resending the auth code');
  }

  const result = await response.json();

  return result;
}

export async function getOrganizations(token) {
  const response = await fetch(`${baseUrl}/get-user-orgs`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });



  if (response.status !== 200) {
    throw Error('There was an error fetching Organizations');
  }

  const result = await response.json();
  return result;
}

export async function getAllOrganizations(token) {
  const response = await fetch(`${baseUrl}/get-all-orgs`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching Organizations');
  }

  const result = await response.json();
  return result;
}

export async function getAllUsers(token) {
  const response = await fetch(`${baseUrl}/get-all-users`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching all Users');
  }

  const result = await response.json();

  return result;
}

export async function getAllTenants(token) {
  const response = await fetch(`${baseUrl}/get-all-tenants`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching all Tenants');
  }

  const result = await response.json();

  return result;
}

export async function getTenants(token) {
  const response = await fetch(`${baseUrl}/get-tenants`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching Tenants');
  }

  const result = await response.json();
  return result;
}

export async function getTenantsAndChannels(token) {
  const response = await fetch(`${baseUrl}/get-tenants-and-channels`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching Tenants');
  }

  const result = await response.json();
  return result;
}

export async function getTenantById(tenantId) {
  const response = await fetch(`${baseUrl}/get-tenant-by-id/${tenantId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching Tenant By URL');
  }

  const result = await response.json();
  return result;
}

export async function getTenantByUrl(domain) {
  const defaultError = 'There was an error fetching Tenant By URL, maybe the connection to the API is not working';

  let response;
  try {
    response = await fetch(`${baseUrl}/get-tenant-by-url/${domain}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch {
    throw Error(defaultError);
  }

  if (response.status !== 200) {
    const body = await response.text().catch(() => '');
    let errorMessage = defaultError;

    try {
      const parsed = JSON.parse(body);
      if (parsed?.message) {
        const [_, message = parsed.message] = parsed.message.split(':');
        errorMessage = message.trim() || parsed.message;
      }
    } catch {
      if (body) {
        errorMessage = body;
      }
    }

    throw Error(errorMessage);
  }

  const result = await response.json();
  return result;
}

export async function getCarrierOrganization(carrierId, token) {
  const response = await fetch(`${baseUrl}/get-carrier-organization/${carrierId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching carrier organizations...');
  }

  const result = await response.json();
  return result;
}

export async function getOwnerCarrier(carrierId, token) {
  const response = await fetch(`${baseUrl}/get-owner-carrier/${carrierId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching owner carrier...');
  }

  const result = await response.json();
  return result;
}

export async function getOwnerParty(carrierId, token) {
  const response = await fetch(`${baseUrl}/get-owner-party/${carrierId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
  });


  if (response.status !== 200) {
    throw Error('There was an error fetching owner party...');
  }

  const result = await response.json();
  return result;
}


export async function getOrganizationUsers(id, token) {
  if (!id) return;
  try {
    const response = await fetch(`${baseUrl}/get-users/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (response.status !== 200) {
      throw Error("There was an error fetching Organization Users");
    }

    const result = await response.json();

    return result.users.reduce(
      (acc, curr) => {
        if (curr.isInvite) {
          acc.invites.push(curr);
        } else {
          acc.users.push(curr);
        }
        return acc;
      },
      {
        invites: [],
        users: []
      }
    );
  } catch (error) {
    console.error("Error in get-users..", error);
  }
}

export async function getUserProfile(organizationId, token) {
  const response = await fetch(`${baseUrl}/get-user-profile/${organizationId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching user profile');
  }

  const result = await response.json();
  return result;
}

export async function getUserProfileById(userId, organizationId, token) {
  const response = await fetch(`${baseUrl}/get-user-profile-by-id/${userId}/${organizationId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching user profile');
  }

  const result = await response.json();
  return result;
}

export async function updateUserProfile(token, user) {

  const response = await fetch(`${baseUrl}/edit-user-profile`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });

  if (response.status !== 200 && response.status !== 204) {
    throw Error('There was an error editing user profile');
  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function updateUserLanguage(token, user) {
  let response = null;
  if (token) {
    response = await fetch(`${baseUrl}/update-language-user`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(user),
    });
    if (response?.status !== 200 && response?.status !== 204) {
      throw Error('There was an error editing user profile');
    }
    if (response?.status === 200) {
      const result = await response?.json();
      return result;
    }
  }
}


export async function updateEmailsProfile(token, user) {
  const response = await fetch(`${baseUrl}/edit-user-email-notifications`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });

  if (response.status !== 200 && response.status !== 204) {
    throw Error('There was an error editing user profile');
  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}
export async function updateTenant(token, id, body) {
  const response = await fetch(`${baseUrl}/edit-tenant/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 200 && response.status !== 204) {
    const result = await response.json();

    throw Error('There was an error updating the tenant.');
  }
  if (response.status === 200) {
    const result = await response.json();
    return result;

  }
}

export async function updateUserRole(token, userId, role, orgId) {
  const response = await fetch(`${baseUrl}/update-user-role`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, role, orgId }),
  });

  if (response.status !== 200 && response.status !== 204) {
    return false;
    throw Error('There was an error editing user role');

  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function updateUserReadOnlyMode(token, userId, readOnly, orgId) {
  const response = await fetch(`${baseUrl}/update-user-read-only`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, readOnly, orgId }),
  });

  if (response.status !== 200 && response.status !== 204) {
    return false;
    throw Error('There was an error editing user role');

  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function updateUserCatalogEdition(token, userId, canEditCatalog, orgId) {
  const response = await fetch(`${baseUrl}/update-user-catalog-edition`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, canEditCatalog, orgId }),
  });

  if (response.status !== 200 && response.status !== 204) {
    return false;
    throw Error('There was an error editing user role');

  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function updateUserRestricted(token, userId, userRestricted, orgId) {
  const response = await fetch(`${baseUrl}/update-user-restricted`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ userId, userRestricted, orgId }),
  });

  if (response.status !== 200 && response.status !== 204) {
    return false;
    throw Error('There was an error editing user role');

  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function getUserNotifications(email, token) {
  let response;
  let url = `${baseUrl}/get-user-notifications`
  if (email) {
    url = `${baseUrl}/get-user-notifications?email=${encodeURIComponent(email)}`
  }
  response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching user notification');
  }

  const result = await response.json();
  return result;
}

export async function updateUserNotifications(token, newSettings) {
  const response = await fetch(`${baseUrl}/edit-user-settings`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(newSettings),
  });

  if (response.status !== 200 && response.status !== 204) {
    throw Error('There was an error editing user notifications');
  }
  if (response.status === 200) {
    const result = await response.json();
    return result;
  }
}

export async function getDocumentsSettings(token) {
  const response = await fetch(`${baseUrl}/get-user-documents-config`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  if (result.length > 0) {
    const settings = {}
    result.forEach(item => {
      settings[item.documentType] = item.sendByEmail;
    })
    return settings;
  } else {
    return {
      '7533': true,
      '7533entry': false,
      'coversheet': false,
      'coversheet321': false,
      'enlargedQR': false,
      'manifest': false,
      'receipt': true,
    }
  }

}

export async function updateUserDocuments(token, newSettings) {
  const response = await fetch(`${baseUrl}/edit-user-document-config`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(newSettings),
  });
}
export async function resendInvite(orgId, inviteId, token) {
  const response = await fetch(`${baseUrl}/resend-invite/${orgId}/${inviteId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error resending the invite');
  }

  const result = await response.json();

  return result;
}

export async function deleteInvite(orgId, inviteId, token) {
  const response = await fetch(`${baseUrl}/delete-invite/${orgId}/${inviteId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error deleting the invite');
  }

  const result = await response.json();

  return result;
}

export async function deleteUser(orgId, userId, token) {
  const response = await fetch(`${baseUrl}/delete-user/${orgId}/${userId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error deleting the user from the org');
  }

  const result = await response.json();

  return result;
}

export async function updateUserStatus(body, token) {
  try {
    const response = await fetch(`${baseUrl}/update-user-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("err in ::updateUserStatus::", err)
  }
}
export async function updateUserStatusSettingsLog(body, token) {
  try {

    const response = await fetch(`${baseUrl}/update-user-status-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();

    return data;
  } catch (err) {
    console.error("err in ::updateUserStatus::", err)
  }
}

export async function getUserSummary(userId, token) {
  const response = await fetch(`${baseUrl}/user/summary/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching user summary');
  }

  const result = await response.json();
  return result;
}

export async function updateNotificationsUser(body, token) {
  try {
    const response = await fetch(`${baseUrl}/edit-notification`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("err in ::updateUserStatus::", err)
  }
}

export async function getNotificationsUser(email, token) {
  let response;
  let url = `${baseUrl}/get-notifications-user`
  if (email) {
    url = `${baseUrl}/get-notifications-user?email=${encodeURIComponent(email)}`
  }
  response = await fetch(url, {

    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching user notification');
  }

  const result = await response.json();
  return result;
}

export async function createPortalNotification(body, token) {
  const response = await fetch(`${baseUrl}/create-portal-notification`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 200) {
    throw Error('There was an error creating notification');
  }

  const result = await response.json();

  return result;
}

export async function getPortalNotification(token, sortByDate) {
  let url = `${baseUrl}/get-portal-notification`
  if (sortByDate) {
    url = `${baseUrl}/get-portal-notification?sortByDate=${sortByDate}`
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching notifications');
  }

  const result = await response.json();
  return result;
}

export async function getNotificationDetails(notificationId, token) {
  const response = await fetch(`${baseUrl}/get-notification-details/${notificationId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching notifications');
  }
  const result = await response.json();
  return result;
}

export async function editPortalNotification(id, body, token) {

  const response = await fetch(`${baseUrl}/edit-portal-notification/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 200) {
    throw Error('There was an error editing notification');
  }

  const result = await response.json();

  return result;
}

export async function getAPIKey(userId, token) {
  const response = await fetch(`${baseUrl}/get-api-key`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    throw Error('There was an error fetching api key');
  }
  const result = await response.json();
  return result.apiKey;
}

export async function setAPIKey(body, token) {
  const response = await fetch(`${baseUrl}/edit-api-key`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 200) {
    throw Error('There was an error editing API key');
  }

  const result = await response.json();

  return result;
}

export async function setWeebhook(id, body, token) {
  const response = await fetch(`${baseUrl}/edit-webhook/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (response.status !== 200) {
    throw Error('There was an error editing Webhook');
  }

  const result = await response.json();

  return result;
}

export async function checkUserRegistry(token, user) {
  const response = await fetch(`${baseUrl}/check-user-registry`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(user),
  });

  const defaultError = 'There was an error checking user registry';

  if (response.status === 400) {
    const error = await tryParseResponse(response);
    // El backend de check-user-registry responde `{ error: "..." }`, no el
    // formato `{ message: "code: text" }` que usa handleBadRequestError en
    // otros endpoints, así que se lee directamente.
    throw Error(error?.error || error?.message || defaultError);
  }

  if (response.status !== 200) {
    throw Error(defaultError);
  }

  const result = await response.json();

  return result;
}

export async function updateTenantUsers(body, token) {
  const response = await fetch(`${baseUrl}/edit-tenant-user`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}


export async function getTenantUsers(tenantId, token) {
  const response = await fetch(`${baseUrl}/get-tenant-users/${tenantId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status !== 200) {
    throw Error('There was an error fetching tenant users');
  }
  const result = await response.json();
  return result;
}
